import { images } from "../../../Assets/assetsHelper";
import "./TeacherProfile.css";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { BaseURL } from "../../../Hooks/URL";
import PersonIcon from "@mui/icons-material/Person";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import Groups2Icon from "@mui/icons-material/Groups2";
import ClassIcon from "@mui/icons-material/Class";
import { useNavigate } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import { MoonLoader } from "react-spinners";
import CourseCard from "../../../Components/Molecules/Cards/CourseCard/CourseCard";

function TeacherProfile({
  teacher,
  setTeacher,
  url,
  setGo,
  loading,
  statistics,
  role,
  // addLoading,
  // setGoSave,
  classes,
  classesLoading,
  setGoActivate,
  addActivateLoading,
}) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {teacher && (
        <>
          {/* Action Buttons */}
          <div className="profileActions">
            {role == "admin" && (
              <button
                className="actionButton primary"
                onClick={() => setGoActivate(true)}
                disabled={addActivateLoading}
              >
                {addActivateLoading ? (
                  <MoonLoader color="white" size={8} />
                ) : null}
                {teacher?.active
                  ? "Deactivate Instructor"
                  : "Activate Instructor"}
              </button>
            )}

            {/* {!teacher?.active && (
              <button
                className="actionButton primary"
                onClick={() => setGoSave(true)}
                disabled={addLoading}
              >
                {addLoading ? <MoonLoader color="white" size={8} /> : null}
                Resend Verification
              </button>
            )} */}

            <button
              className="actionButton primary"
              onClick={() => navigate(`/instructors/add/${teacher.id}`)}
            >
              Edit Instructor
            </button>

            <DeleteForm
              setGo={setGo}
              title={"Are you sure to delete this instructor?"}
            />
          </div>

          {/* About Section */}
          <div className="contentSection">
            <div className="aboutTeacherHeader">
              <div className="teacherLogoSection">
                {teacher?.photoFilePath ? (
                  <img
                    src={`${BaseURL}/${teacher?.photoFilePath}`}
                    alt="Teacher Photo"
                    className="teacherLogo"
                  />
                ) : (
                  <div className="teacherLogoPlaceholder">
                    <PersonIcon style={{ fontSize: "55px" }} />
                  </div>
                )}
              </div>

              <div className="teacherBasicInfo">
                <h1 className="teacherName">{teacher.name}</h1>
              </div>
            </div>

            <h2 className="sectionTitle">Instructor Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">Email</div>
                <div className="infoValue">{teacher?.email}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Phone Number</div>
                <div className="infoValue">{teacher?.phone || "N/A"}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Gender</div>
                <div
                  className="infoValue"
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {teacher?.gender == "male" ? (
                    <MaleIcon className="infoIcon male" />
                  ) : (
                    <FemaleIcon className="infoIcon female" />
                  )}
                  {teacher?.gender == "male" ? "Male" : "Female"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">National ID</div>
                <div className="infoValue">{teacher?.nationalId || "N/A"}</div>
              </div>
              {role === "admin" && (
                <div className="infoItem">
                  <div className="infoLabel">School</div>
                  <div
                    className="infoValue"
                    onClick={() => {
                      if (teacher?.school?.id) {
                        navigate(`/schools/${teacher?.school?.id}`);
                      }
                    }}
                  >
                    <div className="schoolInfo">
                      {teacher?.school?.logo && (
                        <img
                          src={`${BaseURL}/${teacher?.school?.logo}`}
                          alt="School Logo"
                          className="schoolLogo"
                        />
                      )}
                      <span>
                        {teacher?.school ? teacher?.school?.name : "Skill Code"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <div className="infoItem">
                <div className="infoLabel">Status</div>
                <div
                  className={`statusIndicator ${
                    teacher?.active ? "active" : "inactive"
                  }`}
                >
                  {teacher?.active ? <DoneIcon /> : <CloseIcon />}
                  {teacher?.active ? "Activated" : "Not Activated"}
                </div>
              </div>
            </div>
          </div>

          {/* Statistics Grid */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <ClassIcon />
              </div>
              <div className="statContent">
                <h4>Classes</h4>
                <h2>{statistics?.counting?.at(0)?.number_of_classes || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <Groups2Icon />
              </div>
              <div className="statContent">
                <h4>Students</h4>
                <h2>{statistics?.counting?.at(0)?.number_of_students || 0}</h2>
              </div>
            </div>
          </div>

          {/* Latest Classes Section */}
          <div className="contentSection">
            <div className="classesHeader">
              <h2 className="sectionTitle">Latest Classes</h2>
              <button
                className="actionButton primary"
                onClick={() => navigate("/classes")}
              >
                See All Classes
              </button>
            </div>
            {classesLoading ? (
              <div className="loadingContainer">
                <MoonLoader color="#012369" size={40} />
              </div>
            ) : classes?.length ? (
              <div className="classesGrid">
                {classes?.map((item) => (
                  <CourseCard
                    class_id={item?.id}
                    class_name={item?.className}
                    course={item?.course?.title}
                    teacher={item?.teacher?.name}
                    school={item?.school?.name}
                    terminated={item?.isTerminated}
                  />
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <h3>No Classes Assigned Yet</h3>
                <p>
                  Classes will appear here once they are assigned to this
                  instructor
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default TeacherProfile;
